import { render, staticRenderFns } from "./MixerUploadsItemMobile.vue?vue&type=template&id=04a2ffd0&lang=pug&"
import script from "./MixerUploadsItemMobile.vue?vue&type=script&lang=js&"
export * from "./MixerUploadsItemMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports